import { _ } from "libs";
import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { RootState } from "../reducers";
import { Championship } from "../types";
import { getMyChampionships } from "../actions";
import withRedux from "../withRedux";
import Loader from "./loader";
import cx from "classnames";

export const ChampionshipItem = ({ championship, className }: { championship: Championship; className?: string }) => {
	let isExpired = Date.now() / 1000 > championship.endDateTime;
	let tag = null;
	let seatsLeft = championship.settings.maxParticipants - championship.players;
	if (championship.optedIn === false && isExpired) return null;
	if (championship.championshipType === "tournament") {
		if (isExpired) {
			tag = <div className="tag grey">{_("championship.expired")}</div>;
		} else if (championship.optedIn === true) {
			tag = <div className="tag green">{_("championship.tournament.registered")}</div>;
		} else if (championship.settings?.optInDeadline && championship.settings.optInDeadline < Date.now() / 1000) {
			tag = <div className="tag grey">{_("championship.tournament.closed")}</div>;
		} else if (seatsLeft === 0) {
			tag = <div className="tag grey">{_("championship.tournament.soldOut")}</div>;
		} else {
			tag = (
				<div className="tag orange">
					{_("championship.tournament.seatsLeft", seatsLeft, {
						seatsLeft: seatsLeft,
					})}
				</div>
			);
		}
	} else {
		if (championship.optedIn === false) {
			tag = <div className="tag lightGreen">{_("championship.availableToJoin")}</div>;
		}
		if (championship.optedIn === true && isExpired) {
			tag = <div className="tag grey">{_("championship.expired")}</div>;
		}
	}
	return (
		<div
			className={cx(
				"item",
				"championship",
				"medium",
				className,
				{ hasImage: championship.settings?.pictureUrl },
				{ joined: championship.optedIn },
				{ expired: isExpired }
			)}
		>
			{championship.settings?.pictureUrl && (
				<div className="itemImage" style={{ backgroundImage: `url(${championship.settings?.pictureUrl})` }} />
			)}
			<div className="itemBody">
				<div className="title">{championship.name}</div>
				<div className="meta">
					{championship.players} {_("label.players", championship.players || 0)}
				</div>
			</div>
			{tag && <div className="itemExtra">{tag}</div>}
		</div>
	);
};

const ChampionshipBar = ({
	getMyChampionships,
	championships = [],
}: {
	getMyChampionships;
	championships: Championship[];
}) => {
	const [loading, setLoading] = useState(false);

	useEffect(() => {
		let unmounted = false;

		setLoading(true);
		getMyChampionships().then(() => {
			if (!unmounted) {
				setLoading(false);
			}
		});

		return () => {
			unmounted = true;
		};
	}, [getMyChampionships]);

	if (championships === null || loading) {
		return <Loader />;
	} else if (championships.length === 0) {
		return <div className="noResults">{_("championship.list.empty")}</div>;
	} else {
		return (
			<div className="listOfChampionships">
				<div className="wrap">
					{championships.map((championship) => {
						let isExpired = Date.now() / 1000 > championship.endDateTime;
						if (championship.optedIn === false && isExpired) return false;
						return (
							<NavLink to={`/championship/${championship.uuid}`} className="cell" key={championship.uuid}>
								<ChampionshipItem championship={championship} />
							</NavLink>
						);
					})}
				</div>
			</div>
		);
	}
};

export default withRedux({ getMyChampionships }, ({ championships: { championships } }: RootState) => {
	return { championships };
})(ChampionshipBar);
